import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import ReactLoading from 'react-loading';
import { primarycolor } from "../Utils/colors";
import styles from "./../Hostels/houses.module.css";
import styless from './style.module.css';
import { FaStarOfLife } from 'react-icons/fa';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Fetchmypropertiesurl } from '../Utils/urls';
import { getsessionuser, getsessionhouse } from '../Utils/sessions';
import Universalheader from "../Headers/universalheader";
import Addproperty from "./addproperty";
import { Modal } from "@mui/material";



let color = primarycolor;
let type = "spokes";


const Fetchmyproperties = () => {

    const navigate = useNavigate();
    const location = useLocation()


    const sessionuser = getsessionuser();
    const landlorduser = getsessionhouse();
    const [user, setuser] = useState(sessionuser);

    const [progress, setprogress] = useState(true);
    const [properties, setproperties] = useState([]);
    const [error, seterror] = useState('');

    //modals
    const [showaddview, setshowaddview] = useState(false);

    //message from previous page
    const messagef = location.state?.message;


    useEffect(() => {
        getmyproperties();
        if (messagef) {
            setshowaddview(true)
        }
    }, []);

    const getmyproperties = () => {
        seterror('')
        axios.post(Fetchmypropertiesurl, {
            email: user?.email,
        }).then(response => {
            setprogress(false)
            if (!response.data.message) {
                setproperties(response.data)
            } else {
                seterror(response.data.message)
            }
            // 
        }).catch(error => {
            setprogress(false)
            seterror("Sorry an error occurred,try again later");

        });
    }


    //fund account functions
    const onsuccessfund = () => {//on successfund

    }
    const onfailfund = () => {//on fail fund

    }
    const oncancelfund = () => {// in cancel fund modal
        setshowaddview(false)
        getmyproperties()
    }


    return (
        <div className={styles.container}>
            <Modal
                open={showaddview}
                onClose={() => setshowaddview(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Addproperty onsuccessfund={onsuccessfund} onfailfund={onfailfund} oncancelfund={oncancelfund} />
            </Modal>

            <div className={styles.topheader} style={{ paddingBottom: 100 }}>
                <Universalheader />
                <div className={styles.advertisediv}>
                    <FaStarOfLife color={primarycolor} size={15} />
                    <Link to="">
                        <a onClick={() => setshowaddview(true)}>List on Eazistey</a>
                    </Link>
                </div>
                <div className={styles.housenamediv}>
                    <div className={styles.housenamehead}>{user?.username}</div>
                    <div>

                    </div>
                </div>
                <div className={styles.linksdiv}>
                    <Link to="/">
                        <a>Home  /</a>
                    </Link>

                    <a onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>back  /</a>
                    <a style={{ cursor: "pointer" }}>myproperties</a>
                </div>
                <div className={styles.bodydiv}>
                    <div className={styles.housedetailsdiv}>
                        {error &&
                            <div className={styless.errordiv2}><div style={{ color: "red", fontSize: 10 }}>{error}</div>
                                <a style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => setshowaddview(true)}>Click to add property</a>
                            </div>
                        }
                        {!progress && <div className={styless.propertydivwhole}>
                            {
                                properties.map((val, key) => {
                                    return (
                                        <div key={key} className={styless.propertydiv} onClick={() => {
                                            navigate(`/nav/viewsingleproperty/${val.id}`)
                                        }}>
                                            <img src={val.profilepic_url} className={styless.propertydivimage} />
                                            <div className={styless.housedetailsdiv}>
                                                <div style={{ fontWeight: "bold" }}>{val.housename}</div>
                                                <div>ksh {val.price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}/month</div>
                                                <div>{val.location}</div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>}
                        {progress &&
                            <div>
                                <ReactLoading type={type} color={color} height={25} width={20} />
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Fetchmyproperties;